import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';

import { FormFieldOverlay } from './FormFieldOverlay';
import { colors, fontSize, fontWeight } from '../../theme';

export type FormInfoHelpModalProps = {
  visible: boolean;
  onClose: () => void;
  title: string;
  bullets: readonly string[] | string[];
  /** Primary action label (default `OK`). */
  okButtonLabel?: string;
};

/**
 * Shared field help: dimmed scrim, card, title, bullets, X, orange primary (Team + Opportunity modals).
 * Insert lives on `FieldTextAssist`, not here.
 */
export const FormInfoHelpModal: React.FC<FormInfoHelpModalProps> = ({
  visible,
  onClose,
  title,
  bullets,
  okButtonLabel = 'OK',
}) => (
  <FormFieldOverlay
    visible={visible}
    onClose={onClose}
    title={title}
    closeAccessibilityLabel="Close help"
    scrimAccessibilityLabel="Dismiss help overlay"
    footer={
      <TouchableOpacity
        onPress={onClose}
        style={styles.ok}
        accessibilityLabel={okButtonLabel}
        accessibilityRole="button"
        activeOpacity={0.88}
      >
        <Text style={styles.okText}>{okButtonLabel}</Text>
      </TouchableOpacity>
    }
  >
    {bullets.map((line, i) => (
      <View
        key={`form-info-b-${String(i)}`}
        style={styles.bulletRow}
        accessibilityRole="text"
      >
        {bullets.length > 1 ? <Text style={styles.bulletMark}>· </Text> : null}
        <Text style={styles.bodyLine}>{line}</Text>
      </View>
    ))}
  </FormFieldOverlay>
);

const styles = StyleSheet.create({
  bulletRow: {
    flexDirection: 'row' as const,
    alignItems: 'flex-start' as const,
    marginBottom: 8,
  },
  bodyLine: {
    flex: 1,
    fontSize: fontSize.body,
    lineHeight: 20,
    color: colors.textSecondary,
  },
  bulletMark: {
    color: colors.textSecondary,
  },
  ok: {
    marginTop: 8,
    marginHorizontal: 20,
    marginBottom: 16,
    backgroundColor: colors.primary,
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center' as const,
  },
  okText: {
    color: colors.textLight,
    fontSize: 16,
    fontWeight: fontWeight.semibold,
  },
});
